import { NgModule } from '@angular/core';

@NgModule({
  imports: [
  ],
  declarations: [],
  providers: [],
  exports: []
})
export class SharedConsumidorModule { }



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/shared/consumidor-shared.module.ts